import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTransportationDetails } from "../../../actions";
import { selectProcedure } from "../../../selectors";
import { useUpdateEffect } from "../../../../hooks";
import { useCurrentShipmentType } from "../../../../hooks/useCurrentShipmentType";
import { wareHouseKey } from "../../../util/NL_fieldPatterns";
import WarehouseForm from "./warehouseForm";


const WarehouseDetails=({validateError,fieldPattern,saveForm})=>{
  const dispatch=useDispatch()
  const procedure = useSelector(selectProcedure);
  const dataSource=useSelector((state)=>state.Shipment.transportation.warehoueDetails);
  
  const warehouseIdError=useSelector((state)=>state.ValidationErrors.header?.[wareHouseKey]?.msg)
  
  const onUpdate=(params)=>dispatch(updateTransportationDetails({key:"warehoueDetails",payload:params}))
  
  const saveData=(params)=>saveForm({transportation:{warehoueDetails:params}})
  const { isImportShipment }=useCurrentShipmentType()

  const {displayInfo,disableForm}=useMemo(()=>{
    const procList=(isImportShipment) ? ["H6","I2"] :[]
    return {disableForm:(procList.includes(procedure) ? {isDisabled:true} :{}),displayInfo:procList?.toString()}
   },[procedure,isImportShipment])
 
  useUpdateEffect(()=>{
 if(disableForm.isDisabled){
   dispatch(updateTransportationDetails({key:"warehoueDetails",payload:{id:"",type:""}}))
   saveData({id:" ",type:" "})
 }
  },[disableForm.isDisabled])
  

 return (
    <WarehouseForm 
    validateError={validateError}
    fieldPattern={fieldPattern}
    dataSource={dataSource}
    errorInfo={{warehouseIdError}}
    onUpdate={onUpdate}
    saveData={saveData}
    displayInfo={displayInfo && `if procedure code is ${displayInfo} then this section is not allowed and will be disabled.`}
    disableForm={disableForm}
    />
  );
}

export default React.memo(WarehouseDetails)
